import React from "react"
import PropTypes from "prop-types"
import { Box, Typography, Paper, IconButton, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { DownIcon, UpIcon } from "src/components/icons-svg"
import { useLocalStorage } from "src/v2/utils/localstorage-store"

const useStyles = makeStyles((theme) => ({
  card: (props) => ({
    borderRadius: `${props.topIsSquare ? 0 : 11}px ${props.topIsSquare ? 0 : 11}px 11px 11px`,
    background: "#fff", // <-- updated background color
    padding: "16px 24px 16px 16px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "12px 8px 12px 8px",
      flexDirection: "column",
    },
  }),
  numberBox: {
    padding: "10px",
    clipPath: "circle(40%)",
    backgroundColor: "#D2D2D2",
    border: "1px solid #D9D9D9",
    color: "black",
    marginRight: "10px",
    fontSize: "18px",
    textAlign: "center",
    minWidth: 40,
    minHeight: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: 21,
    fontWeight: 300,
    [theme.breakpoints.down("xs")]: {
      fontSize: 17,
    },
  },
  iconButton: {
    fontSize: 24,
    padding: 4,
    marginLeft: "auto", // push icon to the right
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
  },
}))

export default function NumericCard({
  topIsSquare = false,
  children,
  number,
  title,
  id,
}) {
  const [isOpened, setIsOpened] = useLocalStorage("card-opened-" + id, true)
  const classes = useStyles({ topIsSquare })

  function toggleCard(e) {
    e.stopPropagation()
    setIsOpened(!isOpened)
  }

  return (
    <Paper className={classes.card} elevation={2}>
      <Box className={classes.titleRow}>
        <Box className={classes.numberBox}>{number}</Box>
        <Box flex={1}>
          <Typography
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: String(title) }}
          />
        </Box>
        <IconButton
          className={classes.iconButton}
          onClick={toggleCard}
          style={{ marginLeft: "auto" }}
        >
          {isOpened ? DownIcon() : UpIcon()}
        </IconButton>
      </Box>
      {isOpened && (
        <Box mt={2} width="100%" display="block">
          {children}
        </Box>
      )}
    </Paper>
  )
}

NumericCard.propTypes = {
  topIsSquare: PropTypes.bool,
  children: PropTypes.node,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}